import { render, staticRenderFns } from "./ProductMetrcInfo.template.vue?vue&type=template&id=b89c9aaa&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports